import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_pathlessLayout')({
  component: Outlet
});
